import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { advertAPI } from '../api';
import { CLIENT_NOTS, getClientNotify } from './notifySlice';
import { createPromoterExpense } from './officeSlice';
import { getStartOfMonthTimestamp } from '../helpers';

const initialState = {
    isLoaded: false,
    error: null,
    routes: null,
    promoters: null,
    finishedRoutes: null,
    spreadFlyers: null,
    additionalSpreadFlyers: null,
    givenFlyers: null,
    months: null,
    advertPlans: null,
};

export const getAdvertData = createAsyncThunk('advert/fetchAdvert', async ({month}, thunkAPI) => {

    const {routes, promoters, finishedRoutes} = thunkAPI.getState().advert;

    const generalDataLoaded = !!(routes && promoters);

    if (!generalDataLoaded) {
        thunkAPI.dispatch(setLoaded(false));
        const routesData = await advertAPI.getRoutes();
        if (!routesData.isOkay) {
            thunkAPI.dispatch(setError(routesData.message));
            thunkAPI.dispatch(setLoaded(true));
            return;
        };

        const promsData = await advertAPI.getPromoters();
        if (!promsData.isOkay) {
            thunkAPI.dispatch(setError(promsData.message));
            thunkAPI.dispatch(setLoaded(true));
            return;
        }
        thunkAPI.dispatch(setRoutes(routesData.routes));
        thunkAPI.dispatch(setPromoters(promsData.promoters));
    }
    const store = (thunkAPI.getState())
    const {loaded: isDataLoaded} = store.advert.months.find(m => m.month === month);

    if (!isDataLoaded) {
        thunkAPI.dispatch(setLoaded(false));
        const finishedRoutesData = await advertAPI.getFinishedRoutes(month);
        if (!finishedRoutesData.isOkay) {
            thunkAPI.dispatch(setError(finishedRoutesData.message));
            return;
        }
        const mainUTCStr = store.settings.mainUTC;
        try {
            thunkAPI.dispatch(setFinishedRoutes({routes: finishedRoutesData.routes, mainUTCStr}));
            thunkAPI.dispatch(setAdditionalSpreadFlyers(finishedRoutesData.spreadFlyers))
            thunkAPI.dispatch(setAdvertPlans(finishedRoutesData.advertPlans));
        } catch (error) {
            console.log(error)
        }
    }
    thunkAPI.dispatch(changeAdvertMonth(month));
    thunkAPI.dispatch(setAdvertMonthLoaded({}));

    thunkAPI.dispatch(setLoaded(true));
});

export const getFinishedRoute = createAsyncThunk('advert/getFinishedRoute', async ({routeId}, thunkAPI) => {
    const data = await advertAPI.getFinishedRoutes(null, routeId);
    if (data.isOkay) {
        const mainUTCStr = thunkAPI.getState().settings.mainUTC;
        thunkAPI.dispatch(setFinishedRoutes({routes: data.routes, mainUTCStr}));
    } else {
        console.log(data)
        alert(data.message);
    }
})

export const getRoutes = createAsyncThunk('advert/fetchRoutes', async ({multi = false}, thunkAPI) => {
    const data = await advertAPI.getRoutes();
    if (data.isOkay) {
        !multi && thunkAPI.dispatch(setRoutes(data.routes));
        !multi && thunkAPI.dispatch(setLoaded(true));
    } else {
        !multi && alert(data.message);
    }
    return data;
});
export const getPromoters = createAsyncThunk('advert/fetchPromoters', async ({multi = false}, thunkAPI) => {
    const data = await advertAPI.getPromoters();
    if (data.isOkay) {
        !multi && thunkAPI.dispatch(setPromoters(data.promoters));
        !multi && thunkAPI.dispatch(setLoaded(true));
    } else {
        !multi && alert(data.message);
    }
    return data;
});

export const createPromoter = createAsyncThunk('advert/createPromoter', async ({promoterData, resetFunc}, thunkAPI) => {
    const data = await advertAPI.createPromoter(promoterData);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.CREATE_PROMOTER}));
    if (data.isOkay) {
        thunkAPI.dispatch(pushPromoter(data.promoter));
        resetFunc();
    } else {
        console.log(data)
    }
});
export const editPromoter = createAsyncThunk('advert/editPromoter', async ({promoterData, resetFunc}, thunkAPI) => {
    const data = await advertAPI.editPromoter(promoterData);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.EDIT_PROMOTER}));
    if (data.isOkay) {
        thunkAPI.dispatch(updatePromoter(data.promoter));
        resetFunc();
    } else {
        console.log(data)
    }
});
export const deletePromoter = createAsyncThunk('advert/deletePromoter', async ({promoterId, resetFunc}, thunkAPI) => {
    const data = await advertAPI.deletePromoter(promoterId);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.DELETE_PROMOTER}));
    if (data.isOkay) {
        thunkAPI.dispatch(setPromoterDeleted(data.promoter._id));
        resetFunc();
    } else {
        console.log(data)
    }
});
export const recoveryPromoter = createAsyncThunk('advert/recoveryPromoter', async ({promoterId, resetFunc}, thunkAPI) => {
    const data = await advertAPI.deletePromoter(promoterId, true);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.RECOVERY_PROMOTER}));
    if (data.isOkay) {
        thunkAPI.dispatch(setPromoterRecovered(data.promoter._id));
        resetFunc();
    } else {
        console.log(data)
    }
});

export const assignRoute = createAsyncThunk('advert/assignRoute', async ({assignData, resetFunc, enableBtn}, thunkAPI) => {
    const data = await advertAPI.assignRoute(assignData);
    enableBtn();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.ASSIGN_ROUTE}));
    if (data.isOkay) {
        thunkAPI.dispatch(updateRoute(data.route));
        thunkAPI.dispatch(updatePromoter(data.promoter));
        resetFunc();
    } else {
        console.log(data)
    }
});

export const editActiveRoute = createAsyncThunk('advert/editActiveRoute', async ({editData, resetFunc}, thunkAPI) => {
    const data = await advertAPI.editActiveRoute(editData);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.EDIT_ACTIVE_ROUTE}));
    if (data.isOkay) {
        thunkAPI.dispatch(updatePromoter(data.promoter));
        resetFunc();
    } else {
        console.log(data)
    }
});

export const revokeRoute = createAsyncThunk('advert/revokeRoute', async ({routeId, enableBtn}, thunkAPI) => {
    const data = await advertAPI.revokeRoute(routeId);
    enableBtn();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.REVOKE_ROUTE}));
    if (data.isOkay) {
        thunkAPI.dispatch(updateRoute(data.route));
        data.newRoute && thunkAPI.dispatch(updateRoute(data.newRoute));
        thunkAPI.dispatch(updatePromoter(data.promoter));
    } else {
        console.log(data)
    }
});
export const takeRouteToCheck = createAsyncThunk('advert/routeToCheck', async ({promoterId, routeId, isRevision, enableBtns}, thunkAPI) => {
    const data = await advertAPI.takeRouteToCheck(promoterId, routeId, isRevision);
    enableBtns();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.ROUTE_READY_TO_CHECK}));
    if (data.isOkay) {
        thunkAPI.dispatch(setRouteReadyToCheck(data));
    } else {
        console.log(data)
    }
});
export const checkRouteAddress = createAsyncThunk('advert/checkRouteAddress', async (routeData, thunkAPI) => {
    const data = await advertAPI.checkRouteAddress(routeData);
    if (data.isOkay) {
        if (data.porchId !== null) {    //Полный отчет
            thunkAPI.dispatch(setPorchChecked(data))
        } else {
            thunkAPI.dispatch(setAddressChecked(data))
        }
    } else {
        thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.CHECK_ROUTE_ADDRESS}));
        console.log(data)
    }
});

export const rejectRoutePorch = createAsyncThunk('advert/checkRouteAddress', async ({body, resetFunc, unblockBtn}, thunkAPI) => {
    const data = await advertAPI.rejectRoutePorch(body);
    unblockBtn();
    if (data.isOkay) {
        thunkAPI.dispatch(updateRouteProgress(data))
        resetFunc();
    } else {
        thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.REJECT_PORCH}));
        console.log(data)
    }
});

export const deleteRoutePhoto = createAsyncThunk('advert/deleteRoutePhoto', async (photoData, thunkAPI) => {
    const data = await advertAPI.deleteRoutePhoto(photoData);
    if (data.isOkay) {
        thunkAPI.dispatch(updateRouteProgress(data))
    } else {
        thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.DELETE_ROUTE_PHOTO}));
        console.log(data)
    }
});

export const addSpreadFlyers = createAsyncThunk('advert/addSpreadFlyers', async ({flyersData, closeFn, enableBtn}, thunkAPI) => {
    const data = await advertAPI.addSpreadFlyers(flyersData);
    enableBtn();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.ADD_SPREAD_FLYERS}));
    if (data.isOkay) {
        thunkAPI.dispatch(pushAdditionalSpreadFlyers(data.spreadFlyers));
        closeFn();
    } else {
        console.log(data)
    }
});

export const finishRoute = createAsyncThunk('advert/finishRoute', async (finishData, thunkAPI) => {
    const {enableBtns, ...rest} = finishData;
    const data = await advertAPI.finishRoute(rest);
    enableBtns();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.FINISH_ROUTE}));
    if (data.isOkay) {
        thunkAPI.dispatch(setRouteFinished(data));
        thunkAPI.dispatch(updatePromoter(data.promoter));
        data.newRoute && thunkAPI.dispatch(updateRoute(data.newRoute));
        const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
        thunkAPI.dispatch(pushFinishedRoute({route: data.finishedRoute, mainUTCStr}));
    } else {
        console.log(data)
    }
});
export const editFinishedRoute = createAsyncThunk('advert/editFinishedRoute', async (finishData, thunkAPI) => {
    const {closeFn, enableBtn, ...rest} = finishData;
    const data = await advertAPI.editFinishedRoute(rest);
    enableBtn();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.EDIT_FINISHED_ROUTE}));
    if (data.isOkay) {
        const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
        thunkAPI.dispatch(updateFinishedRoute({route: data.finishedRoute, mainUTCStr}));
        closeFn();
    } else {
        console.log(data)
    }
});
export const createFinishedRoute = createAsyncThunk('advert/createFinishedRoute', async (routeData, thunkAPI) => {
    const {closeFn, enableBtn, ...rest} = routeData;
    const data = await advertAPI.createFinishedRoute(rest);
    enableBtn();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.CREATE_FINISHED_ROUTE}));
    if (data.isOkay) {
        const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
        thunkAPI.dispatch(pushFinishedRoute({route: data.finishedRoute, mainUTCStr}));
        closeFn();
    } else {
        console.log(data)
    }
});

export const returnFlyers = createAsyncThunk('advert/returnFlyers', async ({body, resetFn}, thunkAPI) => {
    const data = await advertAPI.returnFlyers(body);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.RETURN_FLYERS}));
    if (data.isOkay) {
        const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
        thunkAPI.dispatch(updateFinishedRoute({route: data.finishedRoute, mainUTCStr}));
        resetFn();
    } else {
        console.log(data)
    }
});

export const checkRoute = createAsyncThunk('advert/checkRoute', async ({finishId, enableBtn}, thunkAPI) => {
    const data = await advertAPI.checkRoute(finishId);
    enableBtn();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.CHECK_ROUTE}));
    if (data.isOkay) {
        thunkAPI.dispatch(setRouteChecked(data.finishId));
    } else {
        console.log(data)
    }
});
export const payForRoute = createAsyncThunk('advert/payForRoute', async ({finishId, enableBtn}, thunkAPI) => {
    const data = await advertAPI.payForRoute(finishId);
    enableBtn();
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.PAY_ROUTE}));
    if (data.isOkay) {
        thunkAPI.dispatch(setRoutePaid(data.finishId));
        thunkAPI.dispatch(createPromoterExpense(data.finishId));
    } else {
        console.log(data)
    }
});

export const setRouteComment = createAsyncThunk('advert/payForRoute', async ({body, resetFn}, thunkAPI) => {
    const data = await advertAPI.setRouteComment(body);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.SET_ROUTE_COMMENT}));
    if (data.isOkay) {
        resetFn();
        data.promoter && thunkAPI.dispatch(updatePromoter(data.promoter))
        const mainUTCStr = (thunkAPI.getState()).settings.mainUTC;
        data.finishedRoute && thunkAPI.dispatch(updateFinishedRoute({route: data.finishedRoute, mainUTCStr}))
    } else {
        console.log(data)
    }
});
export const setRouteLocks = createAsyncThunk('advert/setRouteLocks', async ({body, resetFn}, thunkAPI) => {
    const data = await advertAPI.setRouteLocks(body);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.SET_ROUTE_LOCKS}));
    if (data.isOkay) {
        resetFn();
        thunkAPI.dispatch(updateRouteLocks(data))
    } else {
        console.log(data)
    }
});

export const editAdvertPlan = createAsyncThunk('advert/editPlan', async (planData, thunkAPI) => {
    const data = await advertAPI.editPlan(planData);
    if (data.isOkay) {
        thunkAPI.dispatch(updateAdvertPlan(data))
    } else {
        thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.EDIT_ADVERT_PLAN}));
        console.log(data)
    }
});

// export const getRouteHistory = createAsyncThunk('advert/routeHistory', async (routeId, thunkAPI) => {
//     const data = await advertAPI.editPlan(planData);
//     if (data.isOkay) {
//         thunkAPI.dispatch(updateAdvertPlan(data))
//     } else {
//         thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.EDIT_ADVERT_PLAN}));
//         console.log(data)
//     }
// });



const advertSlice = createSlice({
    name: 'advert',
    initialState,
    reducers: {
        clearAdvertsState(state) {
            state.isLoaded = false;
            state.error = null;
            state.routes = null;
            state.promoters = null;
        },
        setLoaded(state, {payload}) {
            state.isLoaded = payload;
        },
        setError(state, {payload}) {
            state.error = payload;
        },
        setRoutes(state, {payload}) {
            state.routes = payload;
        },
        setPromoters(state, {payload}) {
            state.promoters = payload;
        },
        setAdditionalSpreadFlyers(state, {payload}) {
            const isFirstLoad = state.additionalSpreadFlyers === null;
            const spreadFlyers = isFirstLoad ? payload : payload.filter((sf) => !state.additionalSpreadFlyers.some(sf2 => sf2._id === sf._id))
            state.additionalSpreadFlyers = isFirstLoad ? payload : [...state.additionalSpreadFlyers, ...spreadFlyers];
        },
        setFinishedRoutes(state, {payload}) {
            const isFirstLoad = state.finishedRoutes === null;
            const {routes:unfilteredRoutes, mainUTCStr} = payload;
            const routes = isFirstLoad ? unfilteredRoutes : unfilteredRoutes.filter((r) => !state.finishedRoutes.some(fr => fr._id === r._id))
            state.finishedRoutes = isFirstLoad ? routes : [...state.finishedRoutes, ...routes];

            const spreadFlyersList = [];
            routes.forEach((fr) => {
                fr.spreadFlyers.forEach(sf => {
                    fr.flyers.forEach(f => {
                        if (!f.isOwn) return;
                        spreadFlyersList.push({
                            finishId: fr._id,
                            city: fr.city,
                            promoter: fr.promoter,
                            route: fr.route,
                            flyersCount: sf.flyersCount,
                            flyerType: f,
                            date: sf.dayStamp,
                            timestamp: getStartOfMonthTimestamp(new Date(sf.dayStamp), mainUTCStr),
                        })
                    })
                })
            })
            state.spreadFlyers = isFirstLoad ? spreadFlyersList : [...state.spreadFlyers, ...spreadFlyersList];
            const givenFlyersList = [];
            routes.forEach((fr) => {
                if (!fr.details.givenFlyersCount.some(f => f.count > 0)) {
                    return;
                }
                givenFlyersList.push({
                    finishId: fr._id,
                    city: fr.city,
                    routeId: fr._id,
                    promoter: fr.promoter,
                    sourceType: fr.sourceType,
                    route: fr.route,
                    mailboxCount: fr.mailboxCount,
                    givenFlyersCount: fr.details.givenFlyersCount,
                    date: fr.details.assigned.at,
                    bet: fr.bet,
                    timestamp: getStartOfMonthTimestamp(new Date(fr.details.assigned.at), mainUTCStr),
                    isFinishedRoute: true,
                    isNatural: fr.details.isNatural,
                    comment: fr.comment
                })
            })
            state.givenFlyers = isFirstLoad ? givenFlyersList : [...state.givenFlyers, ...givenFlyersList];
        },
        pushFinishedRoute(state, {payload}) {
            const {route, mainUTCStr} = payload;
            state.finishedRoutes = [...state.finishedRoutes, route];
            const newFlyersList = [];
            (route).spreadFlyers.forEach(sf => {
                (route).flyers.forEach(f => {
                        if (!f.isOwn) return;
                        newFlyersList.push({
                            finishId: route._id,
                            city: route.city,
                            promoter: route.promoter,
                            route: route.route,
                            flyersCount: sf.flyersCount,
                            flyerType: f,
                            date: sf.dayStamp,
                            timestamp: route.details.timestamp,
                        })
                    })
                })
            state.spreadFlyers = [...state.spreadFlyers, ...newFlyersList];

            if (!(route).details.givenFlyersCount.some(f => f.count > 0)) {
                return;
            }
            const newGivenFlyer = {
                finishId: route._id,
                city: route.city,
                routeId: route._id,
                promoter: route.promoter,
                sourceType: route.sourceType,
                mailboxCount: route.mailboxCount,
                route: route.route,
                givenFlyersCount: route.details.givenFlyersCount,
                date: route.details.assigned.at,
                bet: route.bet,
                timestamp: getStartOfMonthTimestamp(new Date(route.details.assigned.at), mainUTCStr),
                isFinishedRoute: true,
                isNatural: route.details.isNatural,
                comment: route.comment
            }
            state.givenFlyers = [...state.givenFlyers, newGivenFlyer];
        },
        pushAdditionalSpreadFlyers(state, {payload}) {
            state.additionalSpreadFlyers = [...state.additionalSpreadFlyers, ...payload];
        },
        updateFinishedRoute(state, {payload}) {
            const {route, mainUTCStr} = payload;
            state.finishedRoutes = state.finishedRoutes.map(fr => fr._id !== route._id ? fr : route);
            state.givenFlyers = state.givenFlyers.map(sf => sf.finishId !== route._id ? sf : ({
                finishId: route._id,
                city: route.city,
                routeId: route._id,
                promoter: route.promoter,
                sourceType: route.sourceType,
                mailboxCount: route.mailboxCount,
                route: route.route,
                givenFlyersCount: route.details.givenFlyersCount,
                date: route.details.assigned.at,
                bet: route.bet,
                timestamp: getStartOfMonthTimestamp(new Date(route.details.assigned.at), mainUTCStr),
                isFinishedRoute: true,
                isNatural: route.details.isNatural,
                comment: route.comment
            }))
        },
        pushPromoter(state, {payload}) {
            state.promoters = [...state.promoters, payload];
        },
        setAdvertMonths(state, { payload }) {
            state.months = payload;
        },
        updateAdvertPlan(state, {payload}) {
            const actionType = payload.actionType;
            const {plan} = payload;
            if (actionType === 'create') {
                state.advertPlans = [...state.advertPlans, plan]
            } else if (actionType === 'edit') {
                state.advertPlans = state.advertPlans.map(p => p._id !== plan._id ? p : plan);
            } else {
                state.advertPlans = state.advertPlans.filter(p => p._id !== plan._id)
            }
        },
        updatePromoter(state, {payload}) {
            state.promoters = state.promoters.map(p => p._id !== payload._id ? p : payload)
        },
        setPromoterDeleted(state, {payload}) {
            state.promoters = state.promoters.map(p => p._id !== payload ? p : {...p, deleted: true})
        },
        setPromoterRecovered(state, {payload}) {
            state.promoters = state.promoters.map(p => p._id !== payload ? p : {...p, deleted: false})
        },
        setPorchChecked(state, {payload}) {
            state.promoters = state.promoters.map(p => {
                if (p._id !== payload.promoterId) return p;
                const thisRouteInfo = payload.isQueueRoute ? p.routeQueue.find(rq => rq._id === payload.routeId) : p.currentRoute;
                thisRouteInfo.progress = thisRouteInfo.progress.map(prg => prg.houseId !== payload.houseId ? prg : ({
                    ...prg,
                    donePorches: prg.donePorches.map(dP => dP.id !== payload.porchId ? dP : ({
                        ...dP,
                        checked: true
                    }))
                }))
                if (!payload.isQueueRoute) {
                    return {
                        ...p,
                        currentRoute: thisRouteInfo
                    }
                }
                return {
                    ...p,
                    routeQueue: p.routeQueue.map(rq => rq._id !== payload.routeId ? rq : thisRouteInfo)
                }
            })
        },
        setAddressChecked(state, {payload}) {
            state.promoters = state.promoters.map(p => {
                if (p._id !== payload.promoterId) return p;
                const thisRouteInfo = payload.isQueueRoute ? p.routeQueue.find(rq => rq._id === payload.routeId) : p.currentRoute;

                thisRouteInfo.progress = thisRouteInfo.progress.map(prg => prg.houseId !== payload.houseId ? prg : ({
                    ...prg,
                    donePorchUrls: prg.donePorchUrls.map(p => ({...p, checked: true}))
                }))

                if (!payload.isQueueRoute) {
                    return {
                        ...p,
                        currentRoute: thisRouteInfo
                    }
                }
                return {
                    ...p,
                    routeQueue: p.routeQueue.map(rq => rq._id !== payload.routeId ? rq : thisRouteInfo)
                }
            })
        },
        updateRoute(state, {payload}) {
            state.routes = state.routes.map(r => r._id !== payload._id ? r : ({
                ...payload,
                addresses: r.addresses,
                coordinates: r.coordinates,
            }));
        },
        setAdvertPlans(state, {payload}) {
            state.advertPlans = payload;
        },
        updateRouteProgress(state, {payload}) {
            state.promoters = state.promoters.map(p => {
                if (p._id !== payload.promoterId) return p;
                const thisRouteInfo = payload.isQueueRoute ? p.routeQueue.find(rq => rq._id === payload.routeId) : p.currentRoute;
                thisRouteInfo.progress = payload.progress;
                if (!payload.isQueueRoute) {
                    return {
                        ...p,
                        currentRoute: thisRouteInfo
                    }
                }
                return {
                    ...p,
                    routeQueue: p.routeQueue.map(rq => rq._id !== payload.routeId ? rq : thisRouteInfo)
                }
            })
        },
        setRouteChecked(state, {payload}) {
            state.finishedRoutes = state.finishedRoutes.map(fr => fr._id !== payload ? fr : ({
                ...fr,
                details: {
                    ...fr.details,
                    checked: true,
                }
            }))
        },
        setRoutePaid(state, {payload}) {
            state.finishedRoutes = state.finishedRoutes.map(fr => fr._id !== payload ? fr : ({
                ...fr,
                details: {
                    ...fr.details,
                    isPaid: true,
                }
            }))
        },
        setRouteReadyToCheck(state, {payload}) {
            const {isQueueRoute} = payload;
            if (isQueueRoute) {
                state.promoters = state.promoters.map(p => {
                    if (p._id !== payload.promoterId) return p;
                    const thisQueueRoute = p.routeQueue.find(rq => rq._id === payload.routeId);
                    thisQueueRoute.readyToCheck = !payload.isRevision;
                    thisQueueRoute.returnedForRevision = payload.isRevision;
                    return {
                        ...p,
                        routeQueue: p.routeQueue.map(rq => rq._id !== payload.routeId ? rq : thisQueueRoute)
                    }
                })
                return;
            }
            state.promoters = state.promoters.map(p => p._id !== payload.promoterId ? p : ({
                ...p,
                currentRoute: {
                    ...p.currentRoute,
                    readyToCheck: !payload.isRevision,
                    returnedForRevision: payload.isRevision,
                }
            }))
        },
        setRouteFinished(state, {payload}) {
            state.routes = state.routes.map(r => r._id !== payload.route._id ? r : ({
                ...r,
                promoter: null,
                details: {
                    ...r.details,
                    started: false,
                    locks: payload.flyerLocks,
                    markedCards: payload.finishedRoute.withCard ? [...r.details.markedCards, ...payload.flyerLocks.map((fl) => ({flyer: fl.flyer, withCard: payload.finishedRoute.withCard}))] : r.details.markedCards
                }
            }))
            state.promoters = state.promoters.map(p => p._id !== payload.promoterId ? p : ({
                ...p,
                currentRoute: {
                    _id: null,
                    id: null,
                    started: false,
                    startedAt: null,
                    readyToCheck: false,
                    returnedForRevision: false,
                    progress: [],
                    withCard: false,
                    bet: null,
                    flyers: [],
                    givenFlyersCount: [],
                    assigned: {
                        by: null,
                        at: null
                    },
                    comment: '',
                }
            }))
        },
        dropPromoterDocument(state, {payload}) {
            state.promoters = state.promoters.map(p => p._id !== payload.promoterId ? p : (
                {
                ...p,
                documents: p.documents.filter(docName => docName !== payload.fileName)
            }))
        },
        updateRouteLocks(state, {payload}) {
            state.routes = state.routes.map(r => r._id !== payload.route._id ? r : ({...r,
                details: {
                    ...r.details,
                    locks: payload.locks
                }
            }))
        },

        updateRouteStarted(state, {payload}) {
            state.promoters = state.promoters.map(p => {
                if (p._id !== payload.promoter._id) return p;
                const newRoute = payload.newRoute;
                if (newRoute) { //if swapped
                    const thisQueueRoute = p.routeQueue.find(rq => rq._id === newRoute._id);
                    thisQueueRoute.started = true;
                    const currentRoute = p.currentRoute;
                    return {
                        ...p,
                        currentRoute: thisQueueRoute,
                        routeQueue: p.routeQueue.map(rq => rq._id !== newRoute._id ? rq : currentRoute)
                    }
                }
                return {
                    ...p,
                    currentRoute: {
                        ...p.currentRoute,
                        started: true
                    }
                }
            });
            state.routes = state.routes.map(r => r._id !== (payload.newRoute?._id || payload.route._id )? r : ({
                ...r,
                details: {
                    ...r.details,
                    started: true,
                }
            }));
        },
        setAdvertMonthLoaded(state, _) {
            state.months = state.months.map(m => m.active ? {
                ...m,
                loaded: true,
            } : m);
        },
        changeAdvertMonth(state, {payload}) {
            state.months = state.months.map(m => m.month === payload ? ({...m, active: true}) : ({...m, active: false}))
        },

    },
    extraReducers: (builder) => {
        
    },
});

export const { updateAdvertPlan, setAdvertPlans, pushAdditionalSpreadFlyers, setAdditionalSpreadFlyers, setAdvertMonthLoaded, changeAdvertMonth, setAdvertMonths, setPromoterDeleted, setPromoterRecovered, updateRouteLocks, setRoutePaid, setRouteChecked, updateFinishedRoute, pushFinishedRoute, setFinishedRoutes, setRouteFinished, setRouteReadyToCheck, setPorchChecked, setAddressChecked, updateRouteProgress, clearAdvertsState, updateRouteStarted, dropPromoterDocument, updateRoute, updatePromoter, pushPromoter, setRoutes, setPromoters, setLoaded, setError } = advertSlice.actions;

export default advertSlice.reducer;
